module.exports = __webpack_public_path__ + "img/arrow-up-landing.f6ecc750.svg";